import {
  HomeIcon,
  DocumentChartBarIcon,
  Cog6ToothIcon,
} from '@heroicons/react/24/outline';
import { PathfinderIcon } from '@/components/icons/PathfinderIcon';
import type { ProductConfig } from '../registry';

export default {
  slug: 'pathfinder',
  icon: PathfinderIcon,
  accentColor: {
    bg: 'bg-cyan-500/10',
    border: 'border-cyan-500/30',
    text: 'text-cyan-400',
  },
  navigation: [
    { name: 'DASHBOARD', href: '/pathfinder/dashboard', icon: HomeIcon },
    { name: 'HISTORY', href: '/pathfinder/history', icon: DocumentChartBarIcon },
    { name: 'SETTINGS', href: '/pathfinder/settings', icon: Cog6ToothIcon },
  ],
  landingPage: '/pathfinder/dashboard',
} satisfies ProductConfig;
